import React from 'react';
import { connect } from 'react-redux';
import { getCurrentCluster, isKafkaCluster } from '@/pages/Layout/MenuLayout/CulsterAddon';
import { isVoid } from '@/utils/common';
import KOPDashboard from './KOPBroker/Dashboard';
import KafkaDashboard from './KafkaBroker/Dashboard';

function Dashboard({ isKafka, currentCluster }) {
  if (isVoid(currentCluster)) return null;
  return isKafka ? <KafkaDashboard /> : <KOPDashboard />;
}

export default connect(
  (state) => ({
    currentCluster: getCurrentCluster(state.kopCluster.allList),
    isKafka: isKafkaCluster(state.kopCluster.allList), // 判断是不是kafka节点集群
  }),
  {},
)(Dashboard);
